export const productTestimonials = [
    {
        "quote": "Les cahiers de révision sont tout simplement exceptionnels ! La qualité du contenu et la clarté des explications m'ont beaucoup aidé à comprendre des concepts difficiles.",
        "author": "Mehdi Ben Ahmed",
        "img": "",
        "rating": 5
    },
    {
        "quote": "J'ai acheté le pack de fiches de révision et je ne le regrette pas du tout. Parfait pour les révisions de dernière minute avant les examens. Je recommande vivement !",
        "author": "Salma Karray",
        "img": "",
        "rating": 4
    },
    {
        "quote": "Service client au top et produits de qualité. Les exercices sont bien pensés et couvrent tout le programme. Un excellent investissement pour la réussite scolaire.",
        "author": "Omar Trabelsi",
        "img": "",
        "rating": 3
    }
];
